import { createSignal, onCleanup, onMount } from "solid-js";

import Icon from "@/components/Icon";
import { useLiveChat } from "@/hooks/livechat/useLiveChat";
import { t } from "@/i18n";

const BackTop = () => {
  const [visible, setVisible] = createSignal(false);
  const visibilityHeight = () => window.innerHeight;
  const { clickLiveChat } = useLiveChat();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  onMount(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setVisible(scrollTop > visibilityHeight());
    };

    // 立即检查一次初始状态
    handleScroll();

    // 监听 window 的滚动
    window.addEventListener("scroll", handleScroll);

    onCleanup(() => {
      window.removeEventListener("scroll", handleScroll);
    });
  });

  return (
    <div
      class={`z-1000 fixed right-6 top-1/2 flex flex-col gap-2 ${visible() ? "visible opacity-100" : "invisible opacity-0"}`}
    >
      <button
        onClick={scrollToTop}
        aria-label="Back to top"
        class={`bg-general-bg1 flex h-[50px] w-[50px] cursor-pointer flex-col items-center justify-center rounded-[10px] text-white shadow-md transition-all duration-300 hover:-translate-y-1`}
      >
        <Icon
          name="general/arrow_up"
          class="text-general-main size-[14px] font-semibold"
        ></Icon>
        <span class="text-general-light text-[16px] font-semibold">
          {t("common.top")}
        </span>
      </button>
      <div
        onclick={() => {
          clickLiveChat();
        }}
        class="bg-general-main flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-[10px] shadow-md transition-all duration-300 hover:-translate-y-1"
      >
        <Icon name="general/service" class="text-general-bg1 size-[26px]" />
      </div>
    </div>
  );
};

export default BackTop;
